import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SmoothScroll } from "@/components/SmoothScroll";
import { LightboxProvider } from "@/components/Lightbox";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Browse from "@/pages/Browse";
import BulkOrder from "@/pages/BulkOrder";
import About from "@/pages/About";
import Enquiry from "@/pages/Enquiry";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <LightboxProvider>
        <div className="App bg-night text-ivory min-h-screen">
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/bulk-order" element={<BulkOrder />} />
            <Route path="/about" element={<About />} />
            <Route path="/enquiry" element={<Enquiry />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: "#121212", border: "1px solid rgba(205,156,32,0.4)", color: "#F2ECDD" } }} />
        </div>
        </LightboxProvider>
      </SmoothScroll>
    </BrowserRouter>
  );
}

export default App;
